import { axiosInstance } from "@/api/client";
import type { AssetDownloadUrlResponse } from "@/domains/documents/types";

/**
 * Requests a fresh signed URL for a private asset. Imperative on purpose:
 * the signed URL is short-lived (TTL ~15 min) and must NEVER be cached or
 * pre-fetched (SPEC AC 2), so this is not wired through a query config.
 */
export const getAssetDownloadUrl = async (
  assetId: string,
): Promise<AssetDownloadUrlResponse> => {
  const { data } = await axiosInstance.get<AssetDownloadUrlResponse>(
    `/v1/assets/${assetId}/download-url`,
  );
  return data;
};
